import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    CreateLlp,
    GetLlpSimulation,
    ILlpPagination,
    IPaginateResult,
    LLPItem,
    LLPListItem,
    MyLlp,
    PayInstallment
} from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class LLPService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}
    getSimulation(payload: GetLlpSimulation) {
        return this.http.post<LLPItem>(`${this.path}/llps/simulate`, payload);
    }

    createLLP(payload: CreateLlp) {
        return this.http.post<LLPItem>(`${this.path}/llps/create`, payload);
    }

    payInstallment(payload: PayInstallment) {
        return this.http.post<MyLlp>(`${this.path}/llps/pay-installment`, payload);
    }

    getMyAll(payload: ILlpPagination) {
        return this.http.post<IPaginateResult<LLPListItem>>(`${this.path}/llps/get-my-all`, payload);
    }

    getMyOne(id: string) {
        return this.http.get<MyLlp>(`${this.path}/llps/${id}`);
    }
}
